(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function arrangeProductTrailer() {
    var productRoot = document.querySelector('[data-hfx-show-type]');
    var isPersonalized = productRoot && productRoot.getAttribute('data-hfx-show-type');
    var holder = isPersonalized
      ? productRoot.querySelector('[data-hfx-custom-product-trailer]')
      : document.querySelector('[data-hfx-product-trailer-global]');
    var video = document.querySelector('.product-single__description .Description-Video, .hfx-product-trailer .Description-Video, .product-single__description .hfx-trailer-panel__video, .hfx-product-trailer .hfx-trailer-panel__video');
    if (!holder || !video) return;

    if (!isPersonalized) {
      productRoot.setAttribute('data-hfx-has-description-video', 'true');
    }

    var videoWrapper = video.parentElement;
    if (videoWrapper.parentElement !== holder) {
      holder.appendChild(videoWrapper);
    }
    holder.hidden = false;
  }

  function arrangeCustomizationSection() {
    var holder = document.querySelector('[data-hfx-customization-holder]');
    var section = document.querySelector('[data-hfx-customization-section]');
    if (!holder || !section) return;

    if (section.parentElement !== holder) {
      holder.appendChild(section);
    }
    section.setAttribute('data-hfx-mounted', 'after-product');
    section.removeAttribute('hidden');
    holder.hidden = false;
  }

  function getPersonalizedShowType(section) {
    var productRoot = section && section.closest('[data-hfx-show-type]');
    var showType = productRoot ? productRoot.getAttribute('data-hfx-show-type') : '';
    return showType || 'garage_blood';
  }

  function initPersonalizedPreview() {
    var section = document.querySelector('[data-hfx-customization-section]');
    if (!section || section.hfxPreviewReady) return;

    var endpoint = 'https://hallowfx-custom-preview.smdoyle.chatgpt.site';
    var textInput = section.querySelector('#hfx-door-text');
    var humanInput = section.querySelector('#hfx-human-check');
    var generateButton = section.querySelector('[data-hfx-generate]');
    var lockButton = section.querySelector('[data-hfx-lock]');
    var uploadInput = section.querySelector('[data-hfx-upload]');
    var preview = section.querySelector('[data-hfx-preview]');
    var previewImage = section.querySelector('[data-hfx-preview-img]');
    var previewStatus = section.querySelector('[data-hfx-preview-status]');
    var error = section.querySelector('[data-hfx-error]');
    var progress = section.querySelector('[data-hfx-progress]');
    var progressBar = section.querySelector('[data-hfx-progress-bar]');
    var progressLabel = section.querySelector('[data-hfx-progress-label]');
    var progressTime = section.querySelector('[data-hfx-progress-time]');
    var productForm = document.querySelector('form[action*="/cart/add"]');
    var approvedAsset = null;
    var progressTimer = null;

    if (!textInput || !humanInput || !generateButton || !lockButton || !previewImage || !productForm) return;
    section.hfxPreviewReady = true;
    section.setAttribute('data-hfx-preview-ready', 'true');

    function setError(message) {
      error.textContent = message || '';
      error.hidden = !message;
    }

    function setBusy(isBusy) {
      generateButton.disabled = isBusy;
      if (uploadInput) uploadInput.disabled = isBusy;
      if (preview) preview.setAttribute('data-busy', isBusy ? 'true' : 'false');
      if (progress) progress.hidden = !isBusy;
    }

    function startProgress() {
      var value = 8;
      var elapsed = 0;
      if (progressBar) progressBar.style.width = value + '%';
      if (progressLabel) progressLabel.textContent = 'Warming the projector...';
      if (progressTime) progressTime.textContent = '0 sec elapsed';
      clearInterval(progressTimer);
      progressTimer = setInterval(function() {
        elapsed += 1;
        value = Math.min(92, value + Math.max(1, Math.round((94 - value) / 14)));
        if (progressBar) progressBar.style.width = value + '%';
        if (progressTime) progressTime.textContent = elapsed + ' sec elapsed';
        if (progressLabel) {
          if (value > 76) {
            progressLabel.textContent = 'Finishing the preview...';
          } else if (value > 44) {
            progressLabel.textContent = 'Painting your custom sign...';
          }
        }
      }, 1000);
    }

    function stopProgress() {
      clearInterval(progressTimer);
      if (progressBar) progressBar.style.width = '100%';
      window.setTimeout(function() { setBusy(false); }, 250);
    }

    function setProperty(name, value) {
      var input = productForm.querySelector('input[name="properties[' + name + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        productForm.appendChild(input);
      }
      input.value = value || '';
    }

    function resetApproval() {
      approvedAsset = null;
      lockButton.disabled = true;
      lockButton.textContent = 'Yes - use this image';
    }

    generateButton.addEventListener('click', async function() {
      var doorText = textInput.value.trim();
      var humanCheck = humanInput.value.trim();
      resetApproval();
      setError('');
      if (!doorText) {
        setError('Enter text for your pirate sign.');
        return;
      }
      if (humanCheck.toLowerCase() !== 'halloween') {
        setError('Please type Halloween in the quick human check.');
        return;
      }

      setBusy(true);
      startProgress();
      if (previewStatus) previewStatus.textContent = 'Creating your personalized preview...';

      try {
        var response = await fetch(endpoint + '/api/generate-garage-preview', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            doorText: doorText,
            humanCheck: humanCheck,
            showType: getPersonalizedShowType(section)
          })
        });
        var result = await response.json();
        if (!response.ok || !result.previewImageUrl) {
          throw new Error(result.error || 'Preview generation is temporarily unavailable.');
        }
        approvedAsset = {
          id: result.generationId,
          imageUrl: result.previewImageUrl,
          source: 'Generated preview',
          doorText: result.doorText || doorText
        };
        previewImage.src = result.previewImageUrl;
        previewImage.alt = 'Personalized pirate sign preview';
        lockButton.disabled = false;
        if (previewStatus) previewStatus.textContent = 'Preview ready. If it looks right, click Yes - use this image.';
      } catch (requestError) {
        setError(requestError && requestError.message ? requestError.message : 'Preview generation is temporarily unavailable.');
        if (previewStatus) previewStatus.textContent = 'The example remains shown. You can retry or upload your own 16:9 image.';
      } finally {
        stopProgress();
      }
    });

    if (uploadInput) {
      uploadInput.addEventListener('change', async function() {
        var file = uploadInput.files && uploadInput.files[0];
        if (!file) return;
        resetApproval();
        setError('');
        setBusy(true);
        if (previewStatus) previewStatus.textContent = 'Uploading your image...';
        try {
          var formData = new FormData();
          formData.append('image', file);
          var response = await fetch(endpoint + '/api/upload-garage-image', {
            method: 'POST',
            body: formData
          });
          var result = await response.json();
          if (!response.ok || !result.uploadedImageUrl) {
            throw new Error(result.error || 'The image could not be uploaded.');
          }
          approvedAsset = {
            id: result.uploadId,
            imageUrl: result.uploadedImageUrl,
            source: 'Customer upload',
            doorText: textInput.value.trim()
          };
          previewImage.src = result.uploadedImageUrl;
          previewImage.alt = 'Uploaded personalized pirate artwork';
          lockButton.disabled = false;
          if (previewStatus) previewStatus.textContent = 'Upload ready. Click Yes - use this image to attach it to your order.';
        } catch (uploadError) {
          setError(uploadError && uploadError.message ? uploadError.message : 'The image could not be uploaded.');
        } finally {
          setBusy(false);
        }
      });
    }

    lockButton.addEventListener('click', function() {
      if (!approvedAsset) return;
      var isUpload = approvedAsset.source === 'Customer upload';
      setProperty(isUpload ? 'Upload ID' : 'Generation ID', approvedAsset.id);
      setProperty(isUpload ? 'Uploaded image URL' : 'Preview image URL', approvedAsset.imageUrl);
      setProperty('Show type', getPersonalizedShowType(section));
      setProperty('Door text', approvedAsset.doorText);
      setProperty('Image source', approvedAsset.source);
      lockButton.textContent = 'Image approved';
      if (previewStatus) previewStatus.textContent = 'Approved image attached to your order. You can now add the show to your cart.';
      setError('');
    });

    textInput.addEventListener('input', resetApproval);
  }

  arrangeProductTrailer();
  arrangeCustomizationSection();
  initPersonalizedPreview();
  var hfxArrangeTimer;
  var hfxProductRoot = document.querySelector('[data-section-type="product"]');
  if (hfxProductRoot && window.MutationObserver) {
    new MutationObserver(function() {
      window.clearTimeout(hfxArrangeTimer);
      hfxArrangeTimer = window.setTimeout(function() {
        arrangeProductTrailer();
        arrangeCustomizationSection();
      }, 0);
    }).observe(hfxProductRoot, { childList: true, subtree: true });
  }
  window.addEventListener('load', function() {
    arrangeProductTrailer();
    arrangeCustomizationSection();
  });
  window.addEventListener('resize', function() {
    arrangeProductTrailer();
    arrangeCustomizationSection();
  });

  } catch(e) { console.error(e); }
})();
})();
